export const Success = 'success';

export class SuccessResponse {
  success?: string;
}
